import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { t, getCurrentLanguage } from '../utils/translations';
import api from './api';
import { CardLoader } from './Loader';

const InFocusSection = () => {
  const [focusItems, setFocusItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentLanguage, setCurrentLanguage] = useState(getCurrentLanguage());

  useEffect(() => {
    const handleLanguageChange = () => setCurrentLanguage(getCurrentLanguage());
    window.addEventListener('languageChanged', handleLanguageChange);
    return () => window.removeEventListener('languageChanged', handleLanguageChange);
  }, []);

  useEffect(() => {
    const fetchFocusItems = async () => {
      try {
        setLoading(true);
        const response = await api.get('/api/focus-items/');
        if (response.data && response.data.length > 0) {
          setFocusItems(response.data);
          setError(null);
        } else {
          setFocusItems([]);
          setError('Aucun élément disponible');
        }
      } catch (err) {
        setError('Erreur de chargement');
        setFocusItems([]);
      } finally {
        setLoading(false);
      }
    };
    fetchFocusItems();
  }, []);

  const cleanHtmlText = (htmlString) => {
    if (!htmlString) return '';
    if (typeof document === 'undefined') return htmlString.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    const tmp = document.createElement('div');
    tmp.innerHTML = htmlString;
    return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
  };

  if (loading) {
    return (
      <section className="py-12 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <CardLoader /><CardLoader /><CardLoader />
          </div>
        </div>
      </section>
    );
  }

  if (error || focusItems.length === 0) return null;

  return (
    <section className="py-12 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4">

        {/* Title - BAD "ZOOM SUR" style with lines */}
        <div className="flex items-center justify-center mb-10">
          <div className="flex-1 h-px bg-[#089556]"></div>
          <h2 className="px-6 text-2xl font-bold text-gray-800 uppercase tracking-wide whitespace-nowrap">
            {t('infocus.title')}
          </h2>
          <div className="flex-1 h-px bg-[#089556]"></div>
        </div>

        {/* Cards Grid - BAD style: 4 columns on one line */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {focusItems.slice(0, 4).map((item) => {
            const title = item.title || '';
            const description = currentLanguage === 'en' && item.description_en
              ? item.description_en
              : item.description_fr || '';

            return (
              <div key={item.id} className="flex flex-col group">
                {/* Image - contained like projects section */}
                <div className="w-full aspect-[4/3] overflow-hidden rounded-lg mb-4 bg-gray-100">
                  <img
                    src={item.image_url || item.image}
                    alt={title}
                    className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                </div>

                {/* Title - bold */}
                <h3 className="text-base font-bold text-gray-900 mb-2 leading-snug line-clamp-2">
                  {title}
                </h3>

                {/* Description */}
                <p className="text-sm text-gray-600 leading-relaxed line-clamp-3 flex-1 mb-3">
                  {cleanHtmlText(description)}
                </p>

                {/* Link - BAD style */}
                <Link
                  to={`/${currentLanguage}/info/${item.slug || item.id}`}
                  className="inline-flex items-center text-[#089556] hover:text-[#0a7c4a] text-sm font-semibold uppercase tracking-wide group/link"
                >
                  {currentLanguage === 'fr' ? 'En savoir plus' : 'Learn more'}
                  <svg className="w-3.5 h-3.5 ml-1.5 group-hover/link:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default InFocusSection;
